<template>
  <form id="restaurarForm" @submit.prevent="submit()" class="ajax_off">
    <div class="form-group">
      <label>Escreva o motivo da restauração:</label>
      <textarea class="form-control" v-model="comentario" required></textarea>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      comentario: null,
    };
  },
  props: {
    tarefa_id: "",
  },
  methods: {
    async submit() {
      await this.$api.put("tarefa/restaurar", {
        tarefa_id: this.tarefa_id,
        comentario: this.comentario,
      });

      this.$emit("getCartao");
      this.$bvModal.hide("restaurar");
    },
  },
};
</script>